import { useEffect } from "react";
import { useHistory } from "react-router-dom";

import { clearSignupContext } from "../../api";
import { SignupContext } from "../../types/data";
import { createBuyNowQuery } from "./createBuyNowQuery";

export const useBuyNowJourney = (businessUserId: string, signupContext: SignupContext, verified: boolean) => {
  const history = useHistory();

  useEffect(() => {
    (async () => {
      if (businessUserId && signupContext && verified) {
        await clearSignupContext(businessUserId);
        const query = createBuyNowQuery(signupContext);
        history.push(`/subscription?${query}`);
      }
    })();
  }, [businessUserId, signupContext, verified]);
};
